import React, { Component } from 'react';
import { Modal, ButtonGroup, Button, Glyphicon, Form, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';

const CONTRACT_TYPES = [
    "ProcurementAgreement",
    "CustomerAgreement",
    "Unknown",
    "NDA_Customer",
    "NDA_Seller",
    "NDA_Mutual",
    "EULA_Customer",
    "EULA_Seller",
    "DistributionAgreement_Customer",
    "DistributionAgreement_Seller",
    "DPA_Controller",
    "DPA_Processor",
    "LicenseAgreement_Customer",
    "LicenseAgreement_Seller",
    "SourcingOfGoods_Customer",
    "SourcingOfGoods_Seller",
    "Services_Customer",
    "Services_Seller",
    "PersonalServices_Customer",
    "PersonalServices_Seller",
    "CarrierAgreement",
    "BrokerAgreement"
];

export default class AddThemePackageButton extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            show: false,
            name: "",
            type: "ProcurementAgreement"
        };
    }

    handleConfirm = () => {
        this.setState({ show: false });
        this.props.onClick(this.state.name, this.state.type);
    }

    handleClose = () => {
        this.setState({ show: false });
    }

    handleShow = () => {
        this.setState({ show: true });
    }

    handleNameChange = (e) => {
        this.setState({ name: e.target.value });
    }

    handleTypeChange = (e) => {
        this.setState({ type: e.target.value });
    }

    getName(type) {
        switch (type) {
            case "ProcurementAgreement": return "Procurement Agreement";
            case "CustomerAgreement": return "Customer Agreement";
            case "NDA_Customer": return "NDA - receiving information";
            case "NDA_Seller": return "NDA - giving information";
            case "NDA_Mutual": return "NDA - both giving and receiving information";
            case "EULA_Seller": return "EULA - Seller";
            case "EULA_Customer": return "EULA - Customer";
            case "DistributionAgreement_Customer": return "Distribution Agreement - Customer";
            case "DistributionAgreement_Seller": return "Distribution Agreement - Seller";
            case "DPA_Controller": return "DPA - Controller";
            case "DPA_Processor": return "DPA - Processor";
            case "LicenseAgreement_Customer": return "License Agreement - Customer";
            case "LicenseAgreement_Seller": return "License Agreement - Seller";
            case "SourcingOfGoods_Customer": return "Sourcing of Goods - Customer";
            case "SourcingOfGoods_Seller": return "Sourcing of Goods - Seller";
            case "Services_Customer": return "Services - Customer";
            case "Services_Seller": return "Services - Seller";
            case "PersonalServices_Customer": return "Personal Services - Customer";
            case "PersonalServices_Seller": return "Personal Services - Seller";
            case "CarrierAgreement": return "Carrier Agreement";
            case "BrokerAgreement": return "Broker Agreement";
            case "Unknown": return "Unknown";
            default: return "Unknown";
        }
    }

    renderMenuItems = () => {
        return CONTRACT_TYPES.map((x, i) => (
            <option value={x}>{this.getName(x)}</option>
        ));
    }

    render() {
        return (
            <ButtonGroup bsSize="small" className="add-btn">
                <Button onClick={this.handleShow}>
                    <Glyphicon glyph='plus' />
                </Button>
                <Modal show={this.state.show} onHide={this.handleClose}>
                    <Modal.Body>
                        <Form className="add-package-modal">
                            <FormGroup controlId="formName">
                                <ControlLabel>The name of the theme</ControlLabel>
                                <FormControl
                                    type="text"
                                    value={this.state.value}
                                    placeholder="Enter name"
                                    onChange={this.handleNameChange}
                                />
                            </FormGroup>
                            <FormGroup controlId="formType">
                                <ControlLabel>The contract type</ControlLabel>
                                <FormControl componentClass="select" placeholder="Procurement Agreement" onChange={this.handleTypeChange}>
                                    {this.renderMenuItems()}
                                </FormControl>
                            </FormGroup>
                            <Button onClick={this.handleConfirm}>Add</Button>
                            <Button onClick={this.handleClose}>Cancel</Button>
                        </Form>
                    </Modal.Body>
                </Modal>
            </ButtonGroup>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CategoryView/AddThemePackageButton.js